// src/store/Profiles/PatientMapSelectSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const PatientMapSelectSlice = createSlice({
  name: 'profiles',
  initialState: {
    PatientSelect: {},
    advancedMdPatientId: null, // <- nuevo campo
  },
  reducers: {
    selectPatient: (state, { payload }) => {
      const { PatientSelect } = payload;
      state.PatientSelect = PatientSelect;
    },
    // 🔹 Guardar el ID del paciente de AdvancedMD (ej. "160842")
    setAdvancedMdPatientId: (state, { payload }) => {
      state.advancedMdPatientId = payload;
    },
  },
});

export const {
  selectPatient,
  setAdvancedMdPatientId,  // <- exportar nueva acción
} = PatientMapSelectSlice.actions;
